<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-bdelivery-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-6">
              <h3 class="mb-0">
                {{ $t("STOCK_MOVEMENTS.STOCK_MOVEMENTS_LIST") }}
              </h3>
            </div>
            <div class="col-6 text-right">
              <base-button
                type="primary"
                icon
                size="sm"
                @click="addStockMovement()"
                v-if="$currentUserCan($permissions.PERM_CREATE_STOCK_MOVEMENTS)"
              >
                <span class="btn-inner--icon">
                  <i class="fas fa-plus"></i>
                </span>
                <span class="btn-inner--text">
                  {{ $t("STOCK_MOVEMENTS.ADD_STOCK_MOVEMENT") }}
                </span>
              </base-button>

              <notification-subscription
                v-if="$currentUserCan($permissions.PERM_VIEW_STOCK_MOVEMENTS)"
                :objectType="'stock-movements'"
                :events="{
                  CREATE: $t('NOTIFICATIONS.EVENT_CREATE'),
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>

        <stock-movement-list-table />
      </card>
    </div>
  </div>
</template>
<script>
import { Button } from "element-ui";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import StockMovementListTable from "./partials/StockMovementListTable.vue";

export default {
  layout: "DashboardLayout",

  components: {
    StockMovementListTable,
    NotificationSubscription,
    [Button.name]: Button,
  },

  mixins: [],

  computed: {},

  watch: {},

  methods: {
    addStockMovement() {
      this.$router.push({ name: "Add StockMovement" });
    },
  },
};
</script>
